import { useEffect, useState } from 'react';

/** タブが前面に戻るたびに増える値。更新の通知が来ないデータを取り直す合図に使う。 */
export const useForegroundRevision = ({ skip = false }: { skip?: boolean } = {}): number => {
  const [revision, setRevision] = useState(0);

  useEffect(() => {
    if (skip) return;

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        setRevision((current) => current + 1);
      }
    };
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => document.removeEventListener('visibilitychange', handleVisibilityChange);
  }, [skip]);

  return revision;
};
